import React, { createContext, useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import useAxios from "../hooks/useAxios";

export const NotificationContextAPI = createContext();

const NotificationContext = ({ children }) => {
  const api = useAxios();
  const id = localStorage.getItem("user.id");
  const token = localStorage.getItem("user.token");
  const [notifications, setNotifications] = useState([]);
  const [userNotifications, setUserNotifications] = useState([]);

  const getNotifications = async () => {
    try {
      const { data } = await api.get(`/tinApproval/approveuserId/${id}`, {
        tokenType: "user",
      });
      setNotifications(data);
    } catch (err) {
      console.error(err);
    }
  };

  const getUserNotifications = async () => {
    try {
      const { data } = await api.get(`/tinApproval/requestByuserId/${id}`, {
        tokenType: "user",
      });
      setUserNotifications(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!id || !token) return;
    getNotifications();
    getUserNotifications();
  }, [id]);

  return (
    <NotificationContextAPI.Provider
      value={{
        notifications,
        setNotifications,
        getNotifications,
        userNotifications
      }}
    >
      {children}
    </NotificationContextAPI.Provider>
  );
};

export default NotificationContext;
